import { customElement } from "lit/decorators.js";

import { BaseSocialButton } from "./base-social-button";

import { facebookLogoTemplate } from "../social-logos/facebook-logo";

@customElement("facebook-login-button")
export class FacebookLoginButton extends BaseSocialButton {
  constructor() {
    super();
    this.provider = "facebook";
  }

  protected override renderContent() {
    return facebookLogoTemplate;
  }
}
